export default __webpack_public_path__ + "static/cards-c4cfe3397fc4da56a934f8d1d86a5b3e.png";